import React, { useMemo } from 'react';

import { isPlayPausePreviewImageEnabled } from '@bingads-webui-campaign-react/play-pause-buttons';
import {
  AdPreviewCarouselLayout,
  AdPreviewCarouselLayoutEx,
} from '@bingads-webui-campaign-react/unified-ad-preview-library-core';

const withAutoRotate = (CarouselLayout) => {
  const Wrapper = ({ enableAutoRotate, permissions, ...rest }) => {
    const autoRotate = useMemo(() => enableAutoRotate && isPlayPausePreviewImageEnabled(permissions), [enableAutoRotate, permissions]);

    return (
      <CarouselLayout
        {...rest}
        enableAutoRotate={autoRotate}
      />
    );
  };
  return Wrapper;
};

export const AdPreviewCarouselLayoutWrapper = withAutoRotate(AdPreviewCarouselLayout);
export const AdPreviewCarouselLayoutWrapperEx = withAutoRotate(AdPreviewCarouselLayoutEx);
